var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPurpleHead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3235_2851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1444 6.73897C23.1444 6.56897 23.1144 6.39897 23.0744 6.23897L22.6544 4.59897C22.2544 3.05897 21.0244 1.88897 19.4644 1.55897L14.0144 0.428969C13.6744 0.358969 13.3244 0.338969 12.9744 0.368969L7.60438 0.838969C6.86438 0.898969 6.14438 1.16897 5.53438 1.59897L2.30437 3.87897C1.47437 4.45897 0.984375 5.40897 0.984375 6.42897V16.069C0.984375 16.209 1.00438 16.349 1.04438 16.489C1.04438 16.489 1.62437 17.829 2.72438 18.509C3.82438 19.189 9.86438 21.669 12.0644 21.789C14.2644 21.909 21.4044 18.959 22.6844 16.959C23.9644 14.959 23.1344 6.72897 23.1344 6.72897L23.1444 6.73897Z",
    fill: "url(#paint0_linear_3235_2851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3955 5.09961H6.42547C4.03547 5.09961 2.10547 7.02961 2.10547 9.41961V12.3096C2.10547 15.0996 3.66547 17.6696 6.14547 18.9496L8.96547 20.4096C11.1155 21.5196 13.6755 21.5196 15.8255 20.4096L18.6455 18.9496C21.1255 17.6696 22.6855 15.1096 22.6855 12.3096V9.41961C22.6855 7.02961 20.7555 5.09961 18.3655 5.09961H12.3955Z",
    fill: "url(#paint1_linear_3235_2851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73541 12.9588C1.74541 13.6288 0.765413 13.1088 0.555413 12.9588C0.155413 12.6888 0.355413 10.2088 0.365413 9.51877C0.365413 9.39877 0.415413 9.28877 0.495413 9.20877C0.645413 9.06877 0.915413 8.88877 1.33541 8.88877C2.01541 8.87877 2.87541 9.63877 2.87541 9.63877L2.73541 12.9588Z",
    fill: "url(#paint2_linear_3235_2851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7747 10.6094C18.1647 10.8494 18.4247 11.2694 18.4247 11.7594C18.4247 12.4994 17.8247 13.1094 17.0747 13.1094C16.3247 13.1094 15.7247 12.5094 15.7247 11.7594C15.7247 11.3594 15.9047 10.9994 16.1847 10.7494C15.1547 11.3194 14.5547 12.7194 14.5547 12.7194C14.5547 12.7194 15.3947 14.4994 17.0747 14.2794C18.7547 14.0594 19.5947 12.7194 19.5947 12.7194C19.5247 11.8694 18.8447 10.9094 17.7747 10.6094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7344 11.7595C15.7344 12.4995 16.3344 13.1095 17.0844 13.1095C17.8344 13.1095 18.4344 12.5095 18.4344 11.7595C18.4344 11.2695 18.1744 10.8495 17.7844 10.6095C17.5444 10.5395 17.2844 10.5095 17.0144 10.5195C16.7244 10.5195 16.4444 10.6195 16.1944 10.7495C15.9144 10.9995 15.7344 11.3595 15.7344 11.7595Z",
    fill: "#3D694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0047 10.5294C18.4647 10.4894 19.4447 11.6094 19.5847 12.6194C19.5847 12.6094 19.5947 12.5994 19.5947 12.5994C19.5047 11.5594 18.5147 10.3594 16.9947 10.3994C15.4847 10.4394 14.5547 12.5994 14.5547 12.5994C14.5547 12.5994 14.5647 12.6194 14.5847 12.6594C14.7547 12.2994 15.6447 10.5694 16.9947 10.5294H17.0047Z",
    fill: "#391909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81414 10.6094C6.42414 10.8494 6.16414 11.2694 6.16414 11.7594C6.16414 12.4994 6.76414 13.1094 7.51414 13.1094C8.26414 13.1094 8.86414 12.5094 8.86414 11.7594C8.86414 11.3594 8.68414 10.9994 8.40414 10.7494C9.43414 11.3194 10.0341 12.7194 10.0341 12.7194C10.0341 12.7194 9.19414 14.4994 7.51414 14.2794C5.83414 14.0594 4.99414 12.7194 4.99414 12.7194C5.06414 11.8694 5.74414 10.9094 6.81414 10.6094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.8543 11.7595C8.8543 12.4995 8.2543 13.1095 7.5043 13.1095C6.7543 13.1095 6.1543 12.5095 6.1543 11.7595C6.1543 11.2695 6.4143 10.8495 6.8043 10.6095C7.0443 10.5395 7.3043 10.5095 7.5743 10.5195C7.8643 10.5195 8.1443 10.6195 8.3943 10.7495C8.6743 10.9995 8.8543 11.3595 8.8543 11.7595Z",
    fill: "#3D694F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58414 10.5294C6.12414 10.4894 5.14414 11.6094 5.00414 12.6194C5.00414 12.6094 4.99414 12.5994 4.99414 12.5994C5.08414 11.5594 6.07414 10.3594 7.59414 10.3994C9.10414 10.4394 10.0341 12.5994 10.0341 12.5994C10.0341 12.5994 10.0241 12.6194 10.0041 12.6594C9.83414 12.2994 8.94414 10.5694 7.59414 10.5294H7.58414Z",
    fill: "#391909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 16.0801C11.084 16.0801 12.234 16.6901 13.564 16.0801C13.564 16.0801 13.074 16.9701 12.324 16.9701C11.574 16.9701 11.084 16.0801 11.084 16.0801Z",
    fill: "#EAA2A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67437 9.70944C9.67437 9.70944 7.84437 9.16944 7.51437 9.12944C7.22438 9.09944 5.96438 9.34944 5.60438 9.41944C5.54438 9.42944 5.48438 9.45944 5.43438 9.50944L4.23438 10.6594L5.62438 9.91944C5.62438 9.91944 5.70438 9.88944 5.74437 9.87944L7.42437 9.69944C7.42437 9.69944 7.51438 9.69944 7.56438 9.70944L9.66437 10.3794V9.68944L9.67437 9.70944Z",
    fill: "#391909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 9.66852C14.6641 9.66852 16.4941 9.12852 16.8241 9.08852C17.1041 9.05852 18.3341 9.29852 18.7141 9.37852C18.7841 9.38852 18.8541 9.42852 18.9041 9.47852L20.0841 10.6185L18.7041 9.88852C18.7041 9.88852 18.6141 9.84852 18.5641 9.84852L16.9041 9.67852C16.8541 9.67852 16.7941 9.67852 16.7441 9.69852L14.6641 10.3685V9.67852V9.66852Z",
    fill: "#391909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6445 13.9094C11.9445 13.9694 12.5845 14.0794 13.1445 13.9394C13.2045 13.9294 13.2445 13.9994 13.2045 14.0394C12.9845 14.2594 12.6145 14.6094 12.4245 14.6694C12.2245 14.7394 11.7845 14.2494 11.5845 13.9994C11.5445 13.9594 11.5845 13.8894 11.6445 13.8994V13.9094Z",
    fill: "url(#paint3_linear_3235_2851)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87547 5.35984L2.10547 7.40984V12.3098H2.87547L3.91547 7.47984L10.1755 7.61984L11.1255 6.38984L12.1755 7.67984L20.6855 7.47984L21.6155 11.8098H22.4055L22.9655 8.24984L20.3355 2.83984L3.65547 4.06984L2.87547 5.35984Z",
    fill: "#391909"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.265 12.7596C23.255 13.4296 24.235 12.9096 24.445 12.7596C24.845 12.4896 24.645 10.0096 24.635 9.31955C24.635 9.19955 24.585 9.08955 24.505 9.00955C24.355 8.86955 24.085 8.68955 23.665 8.68955C22.985 8.67955 22.125 9.43955 22.125 9.43955L22.265 12.7596Z",
    fill: "url(#paint4_linear_3235_2851)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3235_2851",
    x1: 11.8144,
    y1: 1.19897,
    x2: 12.4044,
    y2: 20.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#391909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#3B1C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#442719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#52382E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#634E47"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3235_2851",
    x1: 12.2255,
    y1: 5.27961,
    x2: 12.4855,
    y2: 13.7796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E7B0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFC7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3235_2851",
    x1: 1.64541,
    y1: 8.53877,
    x2: 1.57541,
    y2: 11.0788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E7B0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFC7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3235_2851",
    x1: 12.3945,
    y1: 15.3094,
    x2: 12.3945,
    y2: 13.4094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#DD9291"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E19F9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EAB8B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F1CBCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#F6D9D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#F9E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3235_2851",
    x1: 23.465,
    y1: 8.38955,
    x2: 23.395,
    y2: 10.9396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD9392"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#E7B0AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#EFC7C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F5D7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F8E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE4E2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3235_2851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.39,
    height: 21.44,
    fill: "white",
    transform: "translate(0.304688 0.359375)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleHead);
export default __webpack_public_path__ + "static/media/purple_head.82e0d42a18fbb66e7de15d8dcd0cffea.svg";
export { ForwardRef as ReactComponent };